module.exports = __webpack_public_path__ + "static/media/redeemThumbnail.6b3e60a0.png";